import { usePageTitle } from "context/PageTitleContext";
import DashboardWidget from "components/Dashboard/DashboardWidget";

import styles from "./Dashboard.module.css";
import useGetToDo from "hooks/useGetToDo";
import useGetCurrentCourses from "hooks/useGetCurrentCourses";
import useGetNotices from "hooks/useGetNotices";

const Dashboard = () => {
    usePageTitle("Student Hub");

    const { courses, isLoading: coursesLoading } = useGetCurrentCourses();
    const { toDo, isLoading: todoLoading } = useGetToDo();
    const { notices, isLoading: noticesLoading } = useGetNotices();
    return (
        <div className={styles.dashboardContainer}>
            <DashboardWidget
                title="Courses"
                variant="courses"
                data={courses}
                isLoading={coursesLoading}
            />
            <DashboardWidget
                title="To Do List"
                variant="toDoList"
                data={toDo}
                isLoading={todoLoading}
            />
            <DashboardWidget
                title="Notice Board"
                variant="noticeBoard"
                data={notices}
                isLoading={noticesLoading}
            />
        </div>
    );
};

export default Dashboard;
